import { useParams, useSearchParams } from 'react-router-dom'

import { FinanceBudgetDetailRevampPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { BudgetDetailDataCollection } from 'modules/finance/components/Budgets/BudgetDetailDataCollection'
import { EditTrainingBudgetDialog } from 'modules/finance/components/Budgets/BudgetDetailDataCollection/EditTrainingBudgetDialog'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const BudgetDetailRevampPage = () => {
  const { budgetId } = useParams()
  const id = Number(budgetId)
  const [searchParams, setSearchParams] = useSearchParams()

  const { data, loading, error, refetch } = useQuery(FinanceBudgetDetailRevampPageDocument, {
    variables: {
      budgetId: id,
    },
  })
  const budget = data?.finance?.budget
  const amounts = data?.finance?.budgetAmountsConnection?.nodes[0]

  const isEditOpen = searchParams.get('modal') === 'edit'

  const handleEditClose = () => {
    setSearchParams({})
  }

  const handleEditSuccess = async () => {
    await refetch()
    setSearchParams({})
  }

  return (
    <ResponsivePage.Body loading={loading} error={error}>
      {budget && amounts && <BudgetDetailDataCollection budget={budget} amounts={amounts} />}
      {isEditOpen && budget && (
        <EditTrainingBudgetDialog
          budget={budget}
          onClose={handleEditClose}
          onSuccess={handleEditSuccess}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default BudgetDetailRevampPage
